import React from "react";
import carousleBg from "../../assests/carousleBg.svg";

export default function JudgesInCarousel({
  judges,
  setJudgesPopup,
  setJudgeDetails,
  scrollRef,
}) {
  const handleClickJudge = (obj) => {
    setJudgeDetails(obj);
    setJudgesPopup(true);
  };
  var coverStyle = {
    background: `url(${carousleBg}) center center/contain no-repeat,linear-gradient(81.11deg, rgba(86, 86, 86, 0.4) 25.51%, rgba(21, 21, 21, 0.4) 74.24%) `,
  };
  return (
    <div
      style={coverStyle}
      className="h-[194px] w-[320px] shrink-0 flex-grow flex flex-col  items-center p-[20px]"
      ref={scrollRef}
    >
      <p className="text-regular-medium mb-[10px]">Judges</p>
      <div className=" flex justify-center gap-[3%] w-[100%]">
        {judges?.map((judge) => {
          return (
            <div
              // className="flex flex-col items-center justify-center w-[25%] text-center cursor-pointer "
              className="flex flex-col items-center text-center cursor-pointer "
              onClick={() => handleClickJudge(judge)}
            >
              <img
                src={judge?.logo}
                className="rounded-full w-[60px] h-[60px] object-cover mb-[9px] judgesBg"
              />
              <p className="text-smallest text-[#CDCDCD]   w-[100%]">
                {judge?.name}
              </p>
              <p className="text-smallest2 text-[#606060]  w-[100%]">
                {judge?.position}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
